import * as $ from 'jquery';
import 'bootstrap';
import {bookingFormCommon} from './c005-bookingform-common';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";

export class nfsForm{
	private $viewBookingError:Array<string> = [];
	private bcommon = new bookingFormCommon();
	private $newsletterError:Array<string> = [];
	private pg_apiKey:any = $("#view-nfs--container").attr("data-nfs-apikey"); 

	$scope: any = $('#view-upgrade');
    $scopeMob: any = $('#mob-flightupgrade--container');

	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;
        let $upgrade: any = $('#view-upgrade');
		let $bookFlight: any = $('#book-flight--container');
		let $viewBooking: any = $('#view-booking--container');
		let $flightStatus: any = $('#flight-status--container');
		let $mhStay: any = $('#ibe-stay--container');
		let $mhUpgrade: any = $('#mhupgrade-in--container');
		let $login: any = $('#login-container');
		let $loggedin:any = $('#logged-in-user-menu');
		let $bookFlightMob: any = $('#mobile-bookflight--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $mhStayMob: any = $('#mob-stay--container');
		let $mhUpgradeMob: any = $('#mob-mhupgrade--container');
		let $loginMob: any = $('#mob-login--container');
	  	let $loggedinMob: any = $('#mob-logged-in-user-menu');		
		let $mobMholidays  : any = $('#mobile-mholidays--container');
		let $mhHolidays : any = $('#mholiday-ibe--container');  
		let $checkInMob: any      = $('#mob-checkin--container');
		let $moreLinks: any 	 = $('#more-links--container');
		let $enrichHotel:any         = $('#enrich-hotels-container');
		let $enrichHotelMob:any      = $('#mob-enrich-hotels-container');


		_self.$scope.hide();

		let $checkInRefSel:any             =   $('.checkin-refno--departure');
		let $checkeTicketSel:any           =   $('.checkin-eticket--departure');
		let $checkInRefSelectize:any       =   $checkInRefSel.parent().find('.selectize-control .selectize-input');
		let $checkeTicketSelectize:any     =   $checkeTicketSel.parent().find('.selectize-control .selectize-input');

		let $errorValidationGen:any     = $('.checkin-bookingref--error---validation');
		let $errorValidationEticketGen:any     = $('.checkin-eticketnos--error---validation');

		let $bookingFormTitle:any       = $('.booking-form--title');
		let $nameValidatorGen:any       = $('.name-validator');
		let $numValidatorGen:any        = $('.num-validator');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
		let $navOverlay: any = $('.mab-nav--overlay');
		let $ibeNav: any;
		if($('.ibe-refresh').length >0) {
			$ibeNav = $('.desktop #bookingNav');
		}
		else {
			$ibeNav = $('#bookingNav');
		}		
		_self.$scopeMob.find('.book-opt-viewbooking').parent().addClass('selected');

		/* Start: Moble : If not logged in, redirect to login page */
		let upgradeMilesTabMob = _self.$scopeMob.find('#upgrade-opt-miles');
		let upgradeCashTabMob = _self.$scopeMob.find('#upgrade-opt-cash');
		let $moreLinksMob: any 	 = $('#mob-more-links--container');
		upgradeMilesTabMob.click(function () {
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('#upgrade-opt-miles').parent().addClass('selected');
			let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
			if (loginTokenCookieVal == null) {
				let $earlyMilesLoginUrl: any	=	$('#earlyMilesLoginUrlForUpgrade');
				if (($earlyMilesLoginUrl.val()!='null') && ($earlyMilesLoginUrl.val()!='')) {
					window.location.href = $earlyMilesLoginUrl.val();
				//window.location.href = 'http://localhost:5000/index.html?ibe=upgm';
				}
			}
		});
		/* End: If not logged in, redirect to login page */

		upgradeCashTabMob.click(function () {
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('#upgrade-opt-cash').parent().addClass('selected');
		});

		if (_self.$scopeMob.find('#upgrade-opt-cash').parent().hasClass('selected')) {
			//_self.$scope.show();
		} else if (_self.$scopeMob.find('#upgrade-opt-miles').parent().hasClass('selected')) {
			_self.$scopeMob.show();
		}


		/* Start: If not logged in, redirect to login page */
		let upgradeMilesTab = _self.$scope.find('.upgrade-opt-miles');
		let upgradeCashTab = _self.$scope.find('.upgrade-opt-cash');
		upgradeMilesTab.click(function () {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:upgrade-with-miles',
                'componentType': 'tab',
                'componentName': 'Upgrade With Miles',
                'componentID': '',
				'attributes': []
            });
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.upgrade-opt-miles').parent().addClass('selected');
			let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
			if (loginTokenCookieVal == null) {
				let $earlyMilesLoginUrl: any	=	$('#earlyMilesLoginUrlForUpgrade');
				if (($earlyMilesLoginUrl.val()!='null') && ($earlyMilesLoginUrl.val()!='')) {
					window.location.href = $earlyMilesLoginUrl.val();
				//window.location.href = 'http://localhost:5000/index.html?ibe=upgm';
				}
			}
		});
		/* End: If not logged in, redirect to login page */

		upgradeCashTab.click(function () {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:upgrade-with-cash',
                'componentType': 'tab',
                'componentName': 'Upgrade With Cash',
                'componentID': '',
				'attributes': []
            });
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.upgrade-opt-cash').parent().addClass('selected');
		});

		if (_self.$scope.find('.upgrade-opt-cash').parent().hasClass('selected')) {
			//_self.$scope.show();
		} else if (_self.$scope.find('.upgrade-opt-miles').parent().hasClass('selected')) {
			_self.$scope.show();
		}


		// IBE Navigation show/hide Check in container
		$ibeNav.find('.flight-upgrade').on('click', () => {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-upgrade',
                'componentType': 'tab',
                'componentName': 'Upgrade Top Menu',
                'componentID': '',
				'attributes': []
            });
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.flight-upgrade').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
				let $checkIn     : any = $('#check-in--container');
				$checkIn.hide();
			}
			if($('.ibe-refresh').length >0) {
				let $checkIn     : any = $('#check-in--container');
				$checkIn.hide();
			}
			_self.$scope.show();
			$bookFlight.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$login.hide();
			$mhHolidays.hide();
			$moreLinks.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationEticketGen.hide();
			$enrichHotel.hide();
			$enrichHotelMob.hide();
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			$checkInRefSelectize.removeClass('has-error');
			$checkeTicketSelectize.removeClass('has-error');
			
		});


		// IBE Navigation show/hide Mobile Check in container
		// $mobIbeNav.find('.mobile-flight-upgrade').on('click', () => {
		// 	let $checkInRefSelMob:any          =   $('.mobCheckin-refno--departure');
		// 	let $checkeTicketSelMob:any        =   $('.mobCheckin-eticket--departure');
		// 	let $checkInRefSelectizeMob:any    =   $checkInRefSelMob.parent().find('.selectize-control .selectize-input');
		//     let $checkeTicketSelectizeMob:any  =   $checkeTicketSelMob.parent().find('.selectize-control .selectize-input');
		// 	$('#bookingNav li').removeClass('selected');
		// 	//$mobIbeNav.find('.mobile-check-in').parent().addClass('selected');
		// 	_self.$scopeMob.find('.booking-refno').parent().addClass('selected');
		// 	_self.$scopeMob.show();
		// 	$bookFlightMob.hide();
		// 	$viewBookingMob.hide();
		// 	$flightStatusMob.hide();
		// 	$mobMholidays.hide();			
		// 	$mhStayMob.hide();
		// 	$mhUpgradeMob.hide();
		// 	$loginMob.hide();
		// 	$loggedinMob.hide();
		// 	$errorValidationGen.hide();
		// 	$errorValidationEticketGen.hide();
		// 	$bookingFormTitle.removeClass('has-error');
		// 	$nameValidatorGen.removeClass('has-error');
		// 	$numValidatorGen.removeClass('has-error');
		// 	$couponCodeGen.removeClass('has-error');
		// 	$redemptionLogin.removeClass('has-error');
		// 	$checkInRefSelectizeMob.removeClass('has-error');
		// 	$checkeTicketSelectizeMob.removeClass('has-error');
		// 	bcommon.scrollToTopIBE();

		// });
		if ($('.enrich-revamp').length > 0) {

			$('.mobile-flight-upgrade').on('click', () =>{
				let $checkInRefSelMob:any          =   $('.mobCheckin-refno--departure');
				let $checkeTicketSelMob:any        =   $('.mobCheckin-eticket--departure');
				let $checkInRefSelectizeMob:any    =   $checkInRefSelMob.parent().find('.selectize-control .selectize-input');
				let $checkeTicketSelectizeMob:any  =   $checkeTicketSelMob.parent().find('.selectize-control .selectize-input');
			
				$ibeNavList.removeClass('selected');			
				_self.$scopeMob.find('.book-opt-viewbooking').parent().addClass('selected');
				_self.$scopeMob.show();
				$bookFlightMob.hide();
				$checkInMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$mobMholidays.hide();
				$viewBookingMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$errorValidationGen.hide();
				$moreLinksMob.hide();
				$errorValidationGen.hide();
				$checkInMob.hide();
				$errorValidationEticketGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$nameValidatorGen.removeClass('has-error');
				$numValidatorGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$checkInRefSelectizeMob.removeClass('has-error');
				$checkeTicketSelectizeMob.removeClass('has-error');
				bcommon.scrollToTopIBE();				
				if ($('.enrich-revamp').length > 0) {
					$('.enrich-revamp .enrich-header').addClass('hide');	
					$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');			
					let targetHeight: any = $(window).innerHeight() + 'px';
					$('.enrich-revamp #mob-flightupgrade--container').css('height', targetHeight);					
				}	
			});
		}

		// Overlay container - IBE Navigation show/hide Mobile Check in container
		$navOverlay.find('.mobile-flight-upgrade').on('click', () =>{
			let $checkInRefSelMob:any          =   $('.mobCheckin-refno--departure');
			let $checkeTicketSelMob:any        =   $('.mobCheckin-eticket--departure');
			let $checkInRefSelectizeMob:any    =   $checkInRefSelMob.parent().find('.selectize-control .selectize-input');
			let $checkeTicketSelectizeMob:any  =   $checkeTicketSelMob.parent().find('.selectize-control .selectize-input');

			$ibeNavList.removeClass('selected');
			//$mobIbeNav.find('.mobile-check-in').parent().addClass('selected');
			_self.$scopeMob.find('.book-opt-viewbooking').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mobMholidays.hide();
			$errorValidationGen.hide();
			$checkInMob.hide();
			$errorValidationEticketGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			$checkInRefSelectizeMob.removeClass('has-error');
			$checkeTicketSelectizeMob.removeClass('has-error');
			bcommon.scrollToTopIBE();
			// $scopeCheckinMob.find("input[name='mob_book_opt']").filter('[value=check_in]').prop('checked', true);
		    // $scopeCheckinMob.find('.mob-check-in--containertab').show();
			

			if (window.innerWidth > 767 && window.innerWidth < 1200) {								
				$ibeNav.find('li').removeClass('selected');
				$ibeNav.find('.check-in').parent().addClass('selected');
				_self.$scope.show();
				$bookFlight.hide();
				$viewBooking.hide();				
				$flightStatus.hide();
				$mhStay.hide();
				$mhUpgrade.hide();
				$login.hide();
				$mhHolidays.hide();
				$loggedin.addClass('hidden');
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$errorValidationGen.hide();
				$errorValidationEticketGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$nameValidatorGen.removeClass('has-error');
				$numValidatorGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$checkInRefSelectize.removeClass('has-error');
				$checkeTicketSelectize.removeClass('has-error');

				// let bookOptionVal = _self.$scope.find("input[name='book_opt']").filter('[value=check_in]').prop('checked', true);
				// _self.$scope.find('#view-booking--container').hide();
				// _self.$scope.find('.view-booking--containertab').hide();
				// _self.$scope.find('.check-in--containertab').show();
				// _self.$scope.find('#mob-nfs--container').hide();	
			}


	});



	}
	post_to_url(path:string, params:any): void {
		var method = "post";
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);

		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		form.submit();
	}
	getUrlVars(url:string): any {
		var vars:any = [], hash:any;
		var hashes = url.slice(url.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	viewNfsForm(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let scriptUrl:any = $("#view-nfs--container").attr("data-nfs-scripturl"); 


        // let scriptEl:any = document.createElement('script');
        // scriptEl.src = scriptUrl;
        // scriptEl.async = true;
        // scriptEl.type = "text/javascript";
        // document.getElementsByTagName('body')[0].appendChild(scriptEl);

		let $vbErrorValidation: any = _self.$scope.find('.viewbooking-error--validation');
		let $vbValidator : any = _self.$scope.find('.viewbooking-validator');
		let $vbSubmitBtn: any = _self.$scope.find('.viewBooking');
		let $vbRefNo: any = _self.$scope.find('.view-booking--refno');
		let $vbLastName: any = _self.$scope.find('.view-booking--lastname');
		let $refnoticketnumber:any=_self.$scope.find(".refnoticketnumber-validator");
		let refnoticketnumberVal = $('#view-booking--checkInPnr').val().trim();

		let $mobVBErrorValidation: any = _self.$scopeMob.find('.viewbooking-error--validation');
		let $mobVBValidator : any = _self.$scopeMob.find('.viewbooking-validator');
		let $mobVBSubmitBtn: any = _self.$scopeMob.find('.viewBooking');
		let $mobVBRefNo: any = _self.$scopeMob.find('.view-booking--refno');
		let $mobVBLastName: any = _self.$scopeMob.find('.view-booking--lastname');
		let $mobrefnoticketnumber:any=_self.$scope.find(".refnoticketnumber-validator");
		let ticketNoLimits = [6,14];
		let numberPattern = /^\d+$/;
		let eticketNumberPattern = /^\d{3}-\d{10}$/;
		/** desktop nfs booking submit handler */
		$vbSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			let isUpdagradeCash =$('#view-upgrade ul li.selected a').hasClass('upgrade-opt-cash');
			let isUpdagradeMiles =$('#view-upgrade ul li.selected a').hasClass('upgrade-opt-miles');
			let $validationSuccess    : any = true;
			_self.$viewBookingError = [];
			$vbErrorValidation.show();
		let refnoticketnumberVal = $('#upgrade-booking--checkInPnr').val().trim();

			/** validate PNR. */
			if($vbRefNo.val() == ''){
				let $vbRefNoValidate:any = $vbRefNo.attr('data-eticketno');
				_self.$viewBookingError.push('<strong>'+$vbRefNo.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$vbRefNo.addClass('has-error');
				$vbRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$vbRefNo.removeClass('has-error');
				$vbRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}
			/** validate booking No */
			if($refnoticketnumber.val() == ''){
				let $vbRefNoValidate:any = $refnoticketnumber.attr('data-eticketnolen');
				_self.$viewBookingError.push('<strong>'+$refnoticketnumber.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$refnoticketnumber.addClass('has-error');
				$refnoticketnumber.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			}
			else if (
					!ticketNoLimits.includes(refnoticketnumberVal.length) 
						|| (refnoticketnumberVal.length == 14 && !eticketNumberPattern.test(refnoticketnumberVal))						
				){
				let $vbRefNoValidate:any = $refnoticketnumber.attr('data-eticket');
				_self.$viewBookingError.push('<strong>'+$refnoticketnumber.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$refnoticketnumber.addClass('has-error');
				$refnoticketnumber.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;			
			}
			 else{
				$refnoticketnumber.removeClass('has-error');
				$refnoticketnumber.parent().find('.booking-form--title').removeClass('has-error');
			}
			/** validate Last Name */
			if($vbLastName.val() == ''){
				let $vbLastNameValidate:any = $vbLastName.attr('data-lastname');
				_self.$viewBookingError.push('<strong>'+$vbLastName.parent().find('label').text()+':</strong> '+$vbLastNameValidate);
				$vbLastName.addClass('has-error');
				$vbLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$vbLastName.removeClass('has-error');
				$vbLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $vbValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$viewBookingError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$viewBookingError[i] + '</li>');
			}

			if($validationSuccess) {
				$vbErrorValidation.hide();
				bcommon.preloader();

				if (isUpdagradeCash) {
					adobeDataLayer.push('click', {
						'clickName': 'click:btn-click:upgrade-with-cash-submit',
						'componentType': 'btn',
						'componentName': 'Mh Upgrade Submit',
						'componentID': '',
						'attributes': []
					});
				} else if (isUpdagradeMiles) {
					adobeDataLayer.push('click', {
						'clickName': 'click:btn-click:upgrade-with-miles-submit',
						'componentType': 'btn',
						'componentName': 'Enrich Upgrade Submit',
						'componentID': '',
						'attributes': []
					});
				}
				let tripVal:any  = $vbRefNo.val() || $refnoticketnumber.val()
				_self.errorStatus(tripVal, $vbLastName.val(),'desktop');
				
			}
		});

		/** Mobile -  manage booking submit handler */
		$mobVBSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			let $validationSuccess    : any = true;
			_self.$viewBookingError = [];
			$mobVBErrorValidation.show();
		let refnoticketnumberValmob = _self.$scopeMob.find('#mob-view-booking--checkInPnr').val().trim();
			/** validate View Booking Ref No. */
			if($mobVBRefNo.val() == ''){
				let $mobVbRefNoValidate:any = $mobVBRefNo.attr('data-eticketlen');
				_self.$viewBookingError.push('<strong>'+$mobVBRefNo.parent().find('label').text()+':</strong> '+$mobVbRefNoValidate);
				$mobVBRefNo.addClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			}	else if (
					!ticketNoLimits.includes(refnoticketnumberValmob.length) 
						|| (refnoticketnumberValmob.length == 14 && !eticketNumberPattern.test(refnoticketnumberValmob))						
				){
				let $vbRefNoValidate:any = $refnoticketnumber.attr('data-eticket');
				_self.$viewBookingError.push('<strong>'+$refnoticketnumber.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$mobVBRefNo.addClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;			
			} 
			else{
				$mobVBRefNo.removeClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}
			/** validate Last Name */
			if($mobVBLastName.val() == ''){
				let $mobVBLastNameValidate:any = $mobVBLastName.attr('data-lastname');
				_self.$viewBookingError.push('<strong>'+$mobVBLastName.parent().find('label').text()+':</strong> '+$mobVBLastNameValidate);
				$mobVBLastName.addClass('has-error');
				$mobVBLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$mobVBLastName.removeClass('has-error');
				$mobVBLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $mobVBValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$viewBookingError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$viewBookingError[i] + '</li>');
			}

			if($validationSuccess) {
				$mobVBErrorValidation.hide();
				bcommon.preloader();
				let tripValmob:any  = $mobVBRefNo.val() 
				_self.errorStatus(tripValmob, $mobVBLastName.val(),'mobile');
			/*	var callback = function (response:any) {
					if (response.eligible) {
						window.location.href = response.offerUrl;
					}
					else {
						_self.$viewBookingError.push('<strong> Error: </strong> '+response.message);
						for (var i=0, len=_self.$viewBookingError.length; i<len; i++) {
							$validationMessagelist.append('<li data-id="'+i+'">' + _self.$viewBookingError[i] + '</li>');
						}
						$mobVBErrorValidation.show();
						bcommon.preloaderClose();
					}
				};
				$.getScript(scriptUrl)
				.done(function() {
					var setIntervalID = setInterval(function() {
						clearInterval(setIntervalID);
						plusgrade.lookup(_self.pg_apiKey,$mobVBRefNo.val(), $mobVBLastName.val(), callback);
					}, 1000);
				});
			*/
			}
		});

		
	}
	
  /**
   * return error status in console
   * - for debug only
   * @param {any} refNo    [booking reference input]
   * @param {any} lastName [last name input]
   */
  errorStatus(refNo:any, lastName:any, device:string): boolean {

	let _self = this;
	var bcommon = _self.bcommon;
	var $data:any = {};
	bcommon.preloader();
	if (refNo != '' && lastName != '') {
		var $eTicketNumber = refNo,
		$lastName = lastName;
		$data['upgrade_by'] = 'miles';
		if (window.innerWidth < 767){
			if (_self.$scopeMob.find('#upgrade-opt-cash').parent().hasClass('selected')) {
				$data['upgrade_by'] = 'cash';
			}
		}
		if (_self.$scope.find('.upgrade-opt-cash').parent().hasClass('selected')) {
			$data['upgrade_by'] = 'cash';
		}
		if($data['upgrade_by'] =='miles')
		{	
			$data['SO_SITE_MILES_AND_CASH_UPGD'] = 'TRUE';
			$data['SO_SITE_UPG_MC_MILES_ONLY'] = 'TRUE';
		
				// Logged in user details
				let $dataVal = {
					'flyerId': "",
					'payby': "miles",
					'gts_index': ""
				};

				$.ajax({
					type: 'POST',
					url: '/bin/services/new/retrievemember',
					data: $dataVal,
					success: function(json:any) {
						json = JSON.parse(json);
						var additionalParameters = json.additionalParameters;
						var directLoginParameters = json.directLoginParameters
						var embedTrans = "RetrievePNR";
						var embedTransLabel = "EMBEDDED_TRANSACTION";
						var externalId = "MILESUPGD";
						var site = "desktop";
						$data = {
							REC_LOC: $eTicketNumber,
							DIRECT_RETRIEVE_LASTNAME: $lastName,
							DIRECT_RETRIEVE: 'TRUE',
							TRIP_FLOW: 'YES',
							EMBEDDED_TRANSACTION: embedTrans,
							EXTERNAL_ID: externalId,
							SITE: site,
							SO_GL: '',
							SO_SITE_ALLOW_DIRECT_RT: 'TRUE',
							SO_SITE_ALLOW_PNR_MODIF: 'Y',
							SO_SITE_ALLOW_PNR_SERV: 'YES',
							SO_SITE_ALLOW_TKT_PNR_MODIF: 'Y',
							SO_SITE_DISPL_SPECIAL_REQS: 'TRUE',
							SO_SITE_ETKT_VIEW_ENABLED: 'TRUE',
							SO_SITE_OFFICE_ID: '',
							SO_SITE_PNR_SERV_REQ_LOGIN: 'NO',
							SO_SITE_QUEUE_OFFICE_ID: '',
							SO_SITE_RT_PRICE_FROM_TST: 'TRUE',
							SO_SITE_RT_SHOW_PRICES: 'TRUE',
							VIEW_BOOKING: 'TRUE',
							OVERRIDE_ENABLE: 'TRUE',							
							ACTION : 'MODIFY' ,
							SO_SITE_SPEC_SERV_CHARGEABLE:'TRUE',
							SO_SITE_SRV_CMD_FORMAT_MODE:'DB_FIRST',
							SO_SITE_ALLOW_CASH_UPGRADE:'TRUE',
							SO_SITE_UPGRADE_MODE:'EMD',
							SO_SITE_USE_UPGRADE_PREBOOK:'TRUE',
							SO_SITE_SSR_FILTER_BREAKDOWN:'TIME,UPGD',
							SO_SITE_AWARD_CONVERTER_MODE:'MILES_AND_CASH',
							SO_SITE_ALLOW_AAS_IN_MILES:'SERVICING',
							SO_SITE_SLD_USE_NG_SLIDER:'TRUE',
							SO_SITE_RT_PRICE_FROM_ETKT:'TRUE',
							SO_SITE_MILES_AND_CASH_UPGD:'TRUE',
							SO_SITE_UPG_PAY_FULLY_MILES:'TRUE',
							SO_SITE_RUI_MCONF_ENABLED:'TRUE',
							SO_SITE_RUI_UPGD_SSR_DISABLE:'NONE',
							SO_SITE_UPG_MC_MILES_ONLY:'TRUE',
							SO_SITE_MIL_N_CASH_SLD_MODE:'AAAS',
							SO_SITE_UPGRADE_ALLOW_WL:'FALSE',
							SO_SITE_CASH_UPGRADE_SSR:'UPGD',
							upgrade_by:'miles'
						};

					console.log('Success');

					var $tripFlowUrl = $.param($data) + "&" + directLoginParameters + "" + additionalParameters;
					console.log("tripFlowUrl:" + $tripFlowUrl);
					var $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
					console.log("tripflow_encryptURL:" + $tripflow_encryptURL);
					$.ajax({
						type: 'POST',
						url:'/bin/services/new/ibe',
						data:'url='+ $tripflow_encryptURL,
						success: function(msg:any){
							console.log("##Successful: " + msg);

							var json = msg;
							console.log("##Redirect URL: "+ json.url);
							// window.location.replace(json.url);
							var responseUrl = json.url;
							var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
							_self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
							// bcommon.preloaderClose();
						}
					});
					return true;
				},
				error: function(error:any) {
					console.log("Error while getting member info", error);
				}
				
			});
		}else{
			if(device === 'desktop') {
				// desktop version
				if($('#mhUpgradeSwitch').val() == 'true' && $('#mhUpgradeRedirectUrl').val() != "") {
					window.location.href = $('#mhUpgradeRedirectUrl').val() + '?pnr=' + $eTicketNumber + '&lastname=' + $lastName;
					return;
				}
			} else {
				// mobile version
				if($('#mob-mhUpgradeSwitch').val() == 'true' && $('#mob-mhUpgradeRedirectUrl').val() != "") {
					window.location.href = $('#mob-mhUpgradeRedirectUrl').val()  + '?pnr=' + $eTicketNumber + '&lastname=' + $lastName;
					return;
				}
			}
			var embedTrans = "RetrievePNR";
						var embedTransLabel = "EMBEDDED_TRANSACTION";
						var externalId = "BOOKING";
						var site = "desktop";
						$data = {
							REC_LOC: $eTicketNumber,
							DIRECT_RETRIEVE_LASTNAME: $lastName,
							DIRECT_RETRIEVE: 'TRUE',
							TRIP_FLOW: 'YES',
							EMBEDDED_TRANSACTION: embedTrans,
							EXTERNAL_ID: externalId,
							SITE: site,
							SO_GL: '',
							SO_SITE_ALLOW_DIRECT_RT: 'TRUE',
							SO_SITE_ALLOW_PNR_MODIF: 'Y',
							SO_SITE_ALLOW_PNR_SERV: 'YES',
							SO_SITE_ALLOW_TKT_PNR_MODIF: 'Y',
							SO_SITE_DISPL_SPECIAL_REQS: 'TRUE',
							SO_SITE_ETKT_VIEW_ENABLED: 'TRUE',
							SO_SITE_OFFICE_ID: '',
							SO_SITE_PNR_SERV_REQ_LOGIN: 'NO',
							SO_SITE_QUEUE_OFFICE_ID: '',
							SO_SITE_RT_PRICE_FROM_TST: 'TRUE',
							SO_SITE_RT_SHOW_PRICES: 'TRUE',
							VIEW_BOOKING: 'TRUE',
							OVERRIDE_ENABLE: 'TRUE',
							SO_SITE_UPG_MILES_ONLY: 'FALSE',
							ACTION : 'MODIFY' ,
							SO_SITE_SPEC_SERV_CHARGEABLE:'TRUE',
							SO_SITE_SRV_CMD_FORMAT_MODE:'DB_FIRST',
							SO_SITE_ALLOW_CASH_UPGRADE:'TRUE',
							SO_SITE_UPGRADE_MODE:'EMD',
							SO_SITE_USE_UPGRADE_PREBOOK:'TRUE',
							SO_SITE_SSR_FILTER_BREAKDOWN:'TIME,UPGD',
							SO_SITE_AWARD_CONVERTER_MODE:'MILES_AND_CASH',
							SO_SITE_ALLOW_AAS_IN_MILES:'SERVICING',
							SO_SITE_SLD_USE_NG_SLIDER:'TRUE',
							SO_SITE_RT_PRICE_FROM_ETKT:'TRUE',
							SO_SITE_MILES_AND_CASH_UPGD:'FALSE',
							SO_SITE_UPG_PAY_FULLY_MILES:'TRUE',
							SO_SITE_RUI_MCONF_ENABLED:'TRUE',
							SO_SITE_RUI_UPGD_SSR_DISABLE:'NONE',
							SO_SITE_UPG_MC_MILES_ONLY:'FALSE',
							SO_SITE_MIL_N_CASH_SLD_MODE:'AAAS',
							SO_SITE_UPGRADE_ALLOW_WL:'FALSE',
							SO_SITE_CASH_UPGRADE_SSR:'UPGD'
						};

					console.log('Success');
					var $tripFlowUrl = $.param($data) ;
					console.log("tripFlowUrl:" + $tripFlowUrl);
					var $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
					console.log("tripflow_encryptURL:" + $tripflow_encryptURL);
					$.ajax({
						type: 'POST',
						url:'/bin/services/new/ibe',
						data:'url='+ $tripflow_encryptURL,
						success: function(msg:any){
							console.log("##Successful: " + msg);

							var json = msg;
							console.log("##Redirect URL: "+ json.url);
							// window.location.replace(json.url);
							var responseUrl = json.url;
							var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
							_self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
							// bcommon.preloaderClose();
						}
					});
					return true;
		}
	}
	else {
		console.log('Fail');
		bcommon.preloaderClose();
		return false;
	}
}
	nfsComponentForm(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let $nfsCmpValidator: any = $('#PlusgradeNfs-validator');
		let $nfsCmpPnr: any = $('#PlusgradeNfsEmail');
		let $nfsCmpLastName: any = $('#PlusgradeNfsLastName');
		let $nfsCmpSubmit: any = $('#PlusgradeNfsSubmit');
		let $nfsCmpErrorValidation: any = $('.PlusgradeNfs-error--validation');
		if (_self.$scope.length == 0) { return; }

		$nfsCmpSubmit.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			let $validationSuccess = true;
			_self.$newsletterError = [];
			$nfsCmpErrorValidation.show();

			let $nfsCmpPnrVal       = $nfsCmpPnr.val();
			let $nfsCmpLastNameVal  = $nfsCmpLastName.val();
			let scriptUrl:any = $("#view-nfs--container").attr("data-nfs-scripturl"); 
			if ($nfsCmpPnrVal== ''){
				$validationSuccess = false;
				let $newsletterEmailValidate:any = $nfsCmpPnr.attr('data-pnr');
				_self.$newsletterError.push('<strong>'+$nfsCmpPnr.parent().find('.booking-form--title').text()+':</strong> '+$newsletterEmailValidate);
				$nfsCmpPnr.addClass('has-error');
				$nfsCmpPnr.parent().find('.booking-form--title').addClass('has-error');
			} else {
				$nfsCmpPnr.removeClass('has-error');
				$nfsCmpPnr.parent().find('.booking-form--title').removeClass('has-error');
			}

			if ($nfsCmpLastNameVal == ''){
				$validationSuccess = false;
				$nfsCmpLastName.addClass('has-error');
				$nfsCmpLastName.parent().find('.booking-form--title').addClass('has-error');
				let $preferredCityValidate:any = $nfsCmpLastName.attr('data-lastName');
				_self.$newsletterError.push('<strong>'+$nfsCmpLastName.parent().find('.booking-form--title').text()+':</strong> '+$preferredCityValidate);
			} else {
				$nfsCmpLastName.removeClass('has-error');
				$nfsCmpLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $nfsCmpValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=_self.$newsletterError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + _self.$newsletterError[i] + '</li>');
			}

			if($validationSuccess == true){
				bcommon.preloader();
				$nfsCmpErrorValidation.show();

				var callback = function (response) {

					if (response.eligible) {
						window.location.href = response.offerUrl;
					}
					else {
						_self.$newsletterError.push('<strong> Error: </strong> '+response.message);
						for (var i=0, len=_self.$newsletterError.length; i<len; i++) {
							$validationMessagelist.append('<li data-id="'+i+'">' + _self.$newsletterError[i] + '</li>');
						}
						$nfsCmpErrorValidation.show();
						bcommon.preloaderClose();
					}
				};
				$.getScript(scriptUrl)
				.done(function() {
					var setIntervalID = setInterval(function() {
						clearInterval(setIntervalID);
						plusgrade.lookup(_self.pg_apiKey,$nfsCmpPnrVal, $nfsCmpLastNameVal, callback);
					}, 1000);
				});
							}
		});


	}
  /**
	 * validate both input fields in form for empty state
	 *
	 * if both not empty, hide error message div
	 * else do nothing
	 * @param {any} valEl    [error messages div]
	 * @param {any} refNo    [booking reference input]
	 * @param {any} lastName [last name input]
	 */
	validateEmptyInput(valEl:any, refNo:any, lastName:any): boolean {
  	let _self = this;
		if (refNo.val() != '' && lastName.val() != '') {
			valEl.hide();
			return false;
		}
		else {
			return true;
		}
	}

  /**
   * validate booking reference no
   *
   * if error found:
   * - add 'has-error' class to input and label
   * - append error message to error array obj
   * else:
   * - remove 'has-error' class from input and label
   * @param {any} refNo [booking reference input]
   */
  validateRefNo(refNo:any): boolean {
  	let _self = this;
  	if (refNo.val() == '') {
  		refNo.addClass('has-error');
  		refNo.parent().find('.booking-form--title').addClass('has-error');
  		var validateTicket = refNo.attr('data-eticketno');
  		_self.$viewBookingError.push(validateTicket);
  		return false;
  	}
  	else {
  		refNo.removeClass('has-error');
  		refNo.parent().find('.booking-form--title').removeClass('has-error');
  		return true;
  	}
  }
  validateRefenNo(): void {
	let alphaNumericPattern = /^([a-zA-Z0-9_]+)$/;
		$('.name-validator').off('keydown').on('keydown', function (e: any) {
			// Allow: backspace, delete, tab, escape, enter
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
				// Allow: Ctrl/cmd+A
				(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+C
				(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+X
				(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything
					return;
			}
			// Ensure that it is a number and stop the keypress
			let arr: any = [8,16,17,20,32,35,36,37,38,39,40,45,46];
			for(let i = 65; i <= 90; i++){
				arr.push(i);
			}
			if ($.inArray(e.which, arr) === -1) {
				event.preventDefault();
			}
		});

		$('.alphanum-validator').off('keyup').on('keyup',function (e:any) {
			if (this.value.match(/[^a-zA-Z0-9 ]/g)) {
				this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
			}
		});

		$('.refnoticketnumber-validator').off('keyup').on('keyup',function (e:any) {

			if (this.value.length < 7) {
				if (alphaNumericPattern.test(this.value.replace('-', '')) && isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
				}
			} else if (this.value.length > 6 && e.keyCode != 37 && e.keyCode != 39) {
				if (isNaN(this.value.replace('-', ''))) {
					this.value = this.value.substring(0, 6);
				} else if (!isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^0-9 ]/g, '');
					this.value = this.value.replace(/./g, function(v, i) {
						return i === 2 ? v + "-" : v;
					});
				}
			}
		});

		$('.num-validator').off('keydown').on('keydown', function(e: any) {
			-1 !== $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) || /65|67|86|88/.test(e.keyCode) && (!0 === e.ctrlKey || !0 === e.metaKey) || 35 <= e.keyCode && 40 >= e.keyCode || (e.shiftKey || 48 > e.keyCode || 57 < e.keyCode) && (96 > e.keyCode || 105 < e.keyCode) && e.preventDefault()
		});
  }
  /**
   * validate last name
   *
   * if error found:
   * - add 'has-error' class to input and label
   * - append error message to error array obj
   * else:
   * - remove 'has-error' class from input and label
   * @param {any} refNo [last name input]
   */
  validateLastName(lastName:any): boolean {
  	let _self = this;
  	if (lastName.val() == '') {
  		lastName.addClass('has-error');
  		lastName.parent().find('.booking-form--title').addClass('has-error');
  		var validateLastName_1 = lastName.attr('data-lastname');
  		_self.$viewBookingError.push(validateLastName_1);
  		return false;
  	}
  	else {
  		lastName.removeClass('has-error');
  		lastName.parent().find('.booking-form--title').removeClass('has-error');
  		return true;
  	}
  }

  /**
   * consolidate error messages in error array obj to string
   * and print to error message element
   * @param {any} errorEl [error message element]
   */
  errConsolidate(errorEl:any): void {
  	let _self = this;
  	errorEl.text(_self.$viewBookingError.join(', '));
  	return;
  }

  /**
	 * parse url params to detect view booking deep link
	 * open and populate with params
	 * ?ibe=vwb&bookRef=ABC&lastName=ABC
	 */
	deeplink():void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);

		if (urlParams.ibe && (urlParams.ibe === 'upg' || urlParams.ibe === 'upgm' )) {

			if(urlParams.ibe === 'upgm'){
				_self.$scope.find('.checkin-list li').removeClass('selected');
				_self.$scope.find('.upgrade-opt-miles').parent().addClass('selected');
			}

			// parse url params into ibeFlightUpgradeData object
			let upgData:ibeFlightUpgradeData = {};

			upgData.bookRef = urlParams.bookRef;
			upgData.lastName = urlParams.lastName;
			
			const topNavIbe = $('.desktop#mab-bookingnav #view-upgrade');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-flightupgrade--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav: any;
				if($('.ibe-refresh').length >0) {
					$ibeNav = $('.desktop #bookingNav');
				}
				else {
					$ibeNav = $('#bookingNav');
				}				
				$ibeNav.find('.flight-upgrade').click();
				let bookOptUpgradeTab = _self.$scope.find('.upgrade-opt-cash');
				//bookOptUpgradeTab.click();
				_self.populateOnload(upgData, topNavIbe);
			} else {
				let $navOverlay: any = $('.mab-nav--overlay');
				$navOverlay.find('.mobile-flight-upgrade').click();
				let mobbookOptUpgradeTab = _self.$scopeMob.find('.book-opt-viewbooking');
				//mobbookOptUpgradeTab.click();
				_self.populateOnload(upgData, mobNavIbe);
			}
		}		

	}
	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * for both desktop and mobile ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * @param {ibeFlightUpgradeData} data
	 * @param {any}         instance
	 */
	populateOnload(data:ibeFlightUpgradeData, instance:any): void {		

		let _self = this;
		if (data.bookRef !== undefined) {
			let bookRefInput = instance.find('.check-in--refno');
			bookRefInput.val(decodeURI(data.bookRef)).blur();
			let mobbookRefInput = instance.find('.view-booking--refno');
			mobbookRefInput.val(decodeURI(data.bookRef)).blur();
		}

		// last name
		if (data.lastName !== undefined) {
			let lastNameInput = instance.find('.view-booking--lastname');
			lastNameInput.val(decodeURI(data.lastName)).blur();
		}
	}
}

let scope:Element = document.querySelector('#view-nfs--container');
if (scope){
	try {
        let nfsForms = new nfsForm();
		var adobeDataLayer = new adobeDataLayerWrapper();
        nfsForms.nav();
		nfsForms.viewNfsForm();
		nfsForms.nfsComponentForm();
		nfsForms.validateRefenNo();
		nfsForms.deeplink();
	} catch(e) {console.error(e);}
}